import { useNavigate, useParams } from "react-router-dom";
import { useProject } from "../../../stores/useProject";
import { StyledProject } from "./project.styled";
import { ReactNode, useContext, useEffect, useState } from "react";
import { useProfile } from "../../../stores/useProfile";
import { Project } from "../../../models/Project";
import { Box, Typography, Button } from "@mui/material";
import { ArrowLeft, ArrowLeftIcon } from "@phosphor-icons/react";
import { LanguageContext } from "../../../globals/LanguageContext";
import { formatDateToYYYYMM } from "../../../globals/utils";
import { ContactCard } from "../../../components/project/contactCard/contactCard";
import { ProjectData } from "../../../components/project/projectData/projectData";
import { InvoiceCard } from "../../../components/project/invoiceCard/invoiceCard";
import { QuoteCard } from "../../../components/project/quoteCard/quoteCard";
import { FinancialCard } from "../../../components/project/financialCard/financialCard";
import { DarkOverlay } from "../../../components/darkOverlay/DarkOverlay";
// import { FileEditor } from "../../../components/fileEditor/fileEditor";
import { DirectoryList } from "../../../components/project/directoryList/DirectoryList";
import { useAsyncStatus } from "../../../hooks/useAsyncStatus";
import { Directory } from "../../../models/Directory";

export const ProjectPage = () => {
  const { id } = useParams();
  const { fetchProject, getRoot } = useProject();
  const { user } = useProfile();
  const { dictionary } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [project, setProject] = useState<Project | undefined>();
  const [rootDirectory, setRootDirectory] = useState<Directory | undefined>();
  const [status, setStatus] = useState<string>("");
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const [overlayForm, setoverlayForm] = useState<ReactNode>(<></>);
  const [treeVersion, setTreeVersion] = useState(0);
  const { run, waitingNode } = useAsyncStatus();

  useEffect(() => {
    UpdateItems();
  }, [id]);

  const onClick = (component: ReactNode) => {
    setoverlayForm(component);
    setDarkOverlayOpened(true);
  };

  const UpdateItems = async () => {
    if (!user || !id) return;
    await run(() =>
      fetchProject(user, Number(id)).then((res) => {
        setProject(res);
        setTreeVersion((v) => v + 1);
        res && setStatus(res.status);
      }),
    );
  };

  const retrieveDirectories = async () => {
    if (!user || !project) return;
    await run(() =>
      getRoot(user, Number(project.id)).then((res) => {
        setRootDirectory(res)
      }),
    );
  }

  useEffect(() => {retrieveDirectories()}, [project])

  return (
    <>
      {project && (
        <StyledProject status={status}>
          {waitingNode}
          <DarkOverlay
            opened={darkOverlayOpened}
            component={overlayForm}
            onClose={() => {
              setDarkOverlayOpened(false);
            }}
          />
          <Box className="header">
            <Button
              variant="outlined"
              className="backbtn"
              onClick={() => navigate(`/projects`)}>
              <ArrowLeftIcon size={32} weight="bold" />
              {dictionary.buttons.gobackbtn}
            </Button>
            <Typography variant="h1">
              PRO-{formatDateToYYYYMM(new Date(project.creationDate))}-
              {project.code}
            </Typography>
          </Box>

          <ContactCard project={project} />
          <ProjectData project={project} />
          <DirectoryList
            directory={rootDirectory}
            onChange={UpdateItems}
            key={treeVersion}
            treeVersion={treeVersion}
          />
          <InvoiceCard
            invoices={project.invoices}
            onClick={(component) => onClick(component)}
            onSelect={() => {}}
          />
          <QuoteCard onClick={(component) => onClick(component)} />
        </StyledProject>
      )}
    </>
  );
};
